import EmployeeAbsencesView from 'components/organisms/employee-absences/EmployeeAbsencesView'
import React from 'react'

const Absences = () => {
    return (
        <EmployeeAbsencesView />
    )
}

export default Absences